import { Group, Loader } from '@mantine/core';
import {
  IconArrowBackUp,
  IconArrowLeft,
  IconCalendarPlus,
  IconEdit,
  IconEyeCheck,
  IconEyeOff,
  IconTrash,
  IconTrashOff,
} from '@tabler/icons';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import { EmailBoxContext } from '../../../Service/Context/EmailBoxContext';
import { MessageS } from '../../../Service/MessageS';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { getCustomerId } from '../../../Service/restapi/contactService';
import { saveEventParticipation } from '../../../Service/restapi/eventService';
import { ModalDialog } from '../../../Molecules/Dialogs';
import EventSearchAutocomplete from '../../../Organismns/Event/EventSearchAutocomplete';
import { TransButtonDefault, TransButtonPrimaryWithSpinner } from '../../../Atoms/Buttons';
import { useEventScope } from '../../../Service/hooks/useEventScope';
import ActionIconWithText from './ActionIconWithText';

const EmailPageFooter = () => {
  const { box } = useParams();
  const {
    refresh,
    selectedMessage,
    selectMessage,
    prepareMessage,
    changeEmail,
    changeSeenFlag,
    changingSeenFlag,
    openedFolder,
  } = useContext(EmailBoxContext);
  const [opened, { toggle }] = useDisclosure(false);
  const [selectedEventId, setSelectedEventId] = useState(undefined);
  const { isEventScope } = useEventScope();
  const { executeWithLicenceCheck } = useContext(ViolationContext);

  if (!selectedMessage) {
    return null;
  }
  const { id, readTimestamp, localDateTime, imap } = selectedMessage;

  const deleteHandler = async () => {
    const deleted = await MessageS.deleteEmail(id);
    if (deleted) {
      selectMessage(undefined);
      refresh();
    }
  };

  const trashHandler = async (trash: boolean) => {
    const email = await MessageS.patchEmail(id, { trash });
    if (email) {
      selectMessage(undefined);
      refresh();
    }
  };

  const assignContactToEvent = async () => {
    const patchedEmail = await MessageS.patchEmail(id, { eventId: selectedEventId });
    if (patchedEmail) {
      changeEmail(patchedEmail);
      toggle();
    }

    let participation: any = {
      eventId: selectedEventId,
      eventRole: 'CUSTOMER',
    };
    const customerId = getCustomerId(selectedMessage);

    if (customerId) {
      participation = {
        ...participation,
        contactId: customerId,
      };
    }
    saveEventParticipation(participation);
  };

  console.log(openedFolder)

  const showReply = openedFolder && openedFolder.name.toLowerCase() === 'inbox';
  const showEdit = !imap && ['scheduled', 'failed', 'drafts'].includes(box ?? '') && !localDateTime;
  const showMarkAsRead = !changingSeenFlag && !readTimestamp && (showReply || imap);
  const showMarkAsUnread = !changingSeenFlag && readTimestamp && (showReply || imap);

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Zurück" onClick={() => selectMessage(undefined)} useDefaultWidth>
        <IconArrowLeft />
      </ActionIconWithText>

      <>
        {showReply && (
          <ActionIconWithText useDefaultWidth label="Antwort" onClick={() => prepareMessage('REPLY')}>
            <IconArrowBackUp />
          </ActionIconWithText>
        )}

        {showEdit && (
          <ActionIconWithText useDefaultWidth label="Bearbeiten" onClick={() => prepareMessage('EDIT')}>
            <IconEdit />
          </ActionIconWithText>
        )}
        {changingSeenFlag && <Loader variant="dots" />}
        {showMarkAsRead && (
          <ActionIconWithText label="unerledigt" onClick={() => changeSeenFlag(true)} useDefaultWidth>
            <IconEyeCheck />
          </ActionIconWithText>
        )}
        {showMarkAsUnread && (
          <ActionIconWithText useDefaultWidth label="gelesen" onClick={() => changeSeenFlag(false)}>
            <IconEyeOff />
          </ActionIconWithText>
        )}
        {!imap && !isEventScope && !selectedMessage.eventId && (
          <ActionIconWithText useDefaultWidth label="Event" onClick={toggle}>
            <IconCalendarPlus />
          </ActionIconWithText>
        )}

        {!imap && box === 'trash' && (
          <>
            <ActionIconWithText useDefaultWidth label="Wiederherstellen" onClick={() => trashHandler(false)}>
              <IconTrashOff />
            </ActionIconWithText>
            <ActionIconWithText useDefaultWidth label="Löschen" onClick={deleteHandler}>
              <IconTrash />
            </ActionIconWithText>
          </>
        )}
        {!imap && box !== 'trash' && (
          <ActionIconWithText useDefaultWidth label="Löschen" onClick={() => trashHandler(true)}>
            <IconTrash />
          </ActionIconWithText>
        )}
        {!imap && (
          <ModalDialog
            header="Event zuweisen"
            body={<EventSearchAutocomplete selectEvent={(bookingEvent: any) => setSelectedEventId(bookingEvent.id)} />}
            footer={
              <div>
                <TransButtonPrimaryWithSpinner text="actions.save" icon="SAVE" onClickHandler={assignContactToEvent} />{' '}
                <TransButtonDefault onClickHandler={toggle} text="actions.close" />
              </div>
            }
            show={opened}
            toggle={toggle}
          />
        )}
      </>
    </Group>
  );
};

export default EmailPageFooter;
